<template>
  <div>
    <naj-box :title="local.caseRelatedRequest.addNoteRequest.lawsuitReplyNote">
      <v-row>
        <v-col cols="12">
          <div class="px-3 content-wrapper">
            <h5 class="d-inline-block primary--text font-weight-bold col col-2 mb-4">
              {{ local.caseRelatedRequest.addNoteRequest.prosecutionNotes }}
            </h5>
            <naj-data-table
              no-header
              :loading="loading"
              :headers="lawsuitReplyNoteRequestHeaders"
              :items="prosecutionNotes"
              :disable-items-per-page="true"
              no-margin-bottom
            >
              <template slot-scope="{item}">
                <div class="mx-4">
                  <v-btn
                    icon
                    @click="handleViewAttachment(item)"
                  >
                    <v-icon>
                      mdi-eye
                    </v-icon>
                  </v-btn>
                </div>
              </template>

              <template
                slot="additional-action"
                slot-scope="{item}"
              >
                <span
                  class="show-note"
                  @click="showRequestText(item)"
                >
                  {{ local.caseRelatedRequest.addNoteRequest.fullNoteText }}
                </span>
              </template>
            </naj-data-table>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <div class="px-3 content-wrapper">
            <h5 class="d-inline-block primary--text font-weight-bold col col-2 mb-4">
              {{ local.caseRelatedRequest.addNoteRequest.defenseNotes }}
            </h5>
            <naj-data-table
              no-header
              :loading="loading"
              :headers="lawsuitReplyNoteRequestHeaders"
              :items="defenseNotes"
              :disable-items-per-page="true"
              no-margin-bottom
            >
              <template slot-scope="{item}">
                <div class="mx-4">
                  <v-btn
                    icon
                    @click="handleViewAttachment(item)"
                  >
                    <v-icon>
                      mdi-eye
                    </v-icon>
                  </v-btn>
                </div>
              </template>

              <template
                slot="additional-action"
                slot-scope="{item}"
              >
                <span
                  class="show-note"
                  @click="showRequestText(item)"
                >
                  {{ local.caseRelatedRequest.addNoteRequest.fullNoteText }}
                </span>
              </template>
            </naj-data-table>
          </div>
        </v-col>
      </v-row>
    </naj-box>

    <naj-box :title="local.caseRelatedRequest.addNoteRequest.addNote">
      <v-row>
        <v-col cols="12">
          <naj-input
            :type-id="formFieldType.textarea"
            :label="local.caseRelatedRequest.addNoteRequest.noteText"
            :value.sync="formModel.Desc"
            rows="5"
            validates="required|max:5000|allowed_special_character"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>

    <attachments-list-modal
      :attachments-list="noteAttachments"
      :modal-visibility="showAttachmentInfoModal"
      @modalClose="closeAttachmentInfo"
    ></attachments-list-modal>

    <naj-confirmation
      :show-modal="showNoteRequestInfoModal"
      :max-width="1500"
      :is-persistent="false"
      :title="``"
      :close-btn-label="local.common.back"
      @cancel="closeNoteRequestInfo"
    >
      <template slot="message-content">
        <v-row>
          <v-col
            v-if="selectedNoteRequest && selectedNoteRequest.requestText"
            class="mx-12"
          >
            <naj-item-description
              :title="local.caseRelatedRequest.addNoteRequest.requestText"
              :message="selectedNoteRequest.requestText"
            >
            </naj-item-description>
          </v-col>

          <v-col v-else>
            <h1>
              {{ local.caseRelatedRequest.addNoteRequest.requestTextNoData }}
            </h1>
          </v-col>
        </v-row>
      </template>
    </naj-confirmation>
  </div>
</template>

<script>
import { mode, socialIdentityTypeEnum, countriesEnum, casePartyRoleEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');
import { toGeorgianDateString } from '@/helpers/utils';
import AttachmentsListModal from '@/components/shared/attachment-modal/attachments-list-modal';

export default {
  name: 'AddNoteRequest',
  inject: ['$validator'],
  components: { AttachmentsListModal },
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      noteAttachments: [],
      showAttachmentInfoModal: false,
      toGeorgianDateString,
      lawsuitReplyNoteRequest: [],
      loading: false,
      showNoteRequestInfoModal: false,
      selectedNoteRequest: null,
      lawsuitReplyNoteRequestHeaders: [
        {
          value: 'requesterName',
          text: this.local.caseRelatedRequest.addNoteRequest.requesterName,
        },
        {
          value: 'roleInCaseName',
          text: this.local.caseRelatedRequest.addNoteRequest.roleInCase,
        },
        {
          value: 'requestDate',
          text: this.local.caseRelatedRequest.addNoteRequest.replyNoteRequestDate,
        },
        {
          value: 'additional-action',
          text: this.local.caseRelatedRequest.addNoteRequest.requestText,
        },
        {
          value: 'action',
          text: this.local.caseRelatedRequest.addNoteRequest.attachments,
        },
      ],
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
    prosecutionNotes() {
      return this.lawsuitReplyNoteRequest.filter(note => note.roleInCaseId == casePartyRoleEnum.prosecutor || note.roleInCaseId == casePartyRoleEnum.agent);
    },
    defenseNotes() {
      return this.lawsuitReplyNoteRequest.filter(note => note.roleInCaseId == casePartyRoleEnum.defendant || note.roleInCaseId == casePartyRoleEnum.wiseness);
    },
  },
  watch: {},
  mounted() {
    this.readCurrentUserInfo();

    this.loading = true;
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };

    this.getLawsuitReplyNoteRequest(params)
      .then((res) => {
        this.lawsuitReplyNoteRequest = (res.data || []).map(note => ({
          ...note,
          requestDate: toGeorgianDateString(note.requestDate),
        }));
      })
      .finally(() => (this.loading = false));
  },
  created() {
  },
  methods: {
    ...mapActions([
      'getLawsuitReplyNoteRequest',
    ]),
    handleViewAttachment(note) {
      const requestData = JSON.parse(note.requestData || '{ "requestReasons": [] }');
      const requestReasonsAttachments = (requestData.requestReasons || [])
        .filter(r => r.sharePointID && r.sharePointFileName)
        .map(r => ({
          fileName: r.sharePointFileName,
          sharepointId: r.sharePointID,
        }));
      this.$set(this, 'noteAttachments', requestReasonsAttachments);
      this.showAttachmentInfoModal = true;
    },
    closeAttachmentInfo() {
      this.showAttachmentInfoModal = false;
    },
    showRequestText(note) {
      this.showNoteRequestInfoModal = true;
      this.selectedNoteRequest = note;
    },
    closeNoteRequestInfo() {
      this.showNoteRequestInfoModal = false;
      this.selectedNoteRequest = null;
    },
    readCurrentUserInfo() {
      if (this.userInfo) {
        const socialTypeId = this.userInfo.socialIdType;
        this.$set(this.formModel, 'socialIdType', socialTypeId);
        this.$set(this.formModel, 'socialId', this.userInfo.socialId);
        this.$set(this.formModel, 'firstName', this.userInfo.firstName);
        this.$set(this.formModel, 'fatherName', this.userInfo.fatherName);
        this.$set(this.formModel, 'grandFatherName', this.userInfo.grandFatherName);
        this.$set(this.formModel, 'familyName', this.userInfo.familyName);
        this.$set(this.formModel, 'dateOfBirth', this.userInfo.dateOfBirth);
        this.$set(this.formModel, 'nationalityCountryId', socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
        this.$set(this.formModel, 'sex', this.userInfo.gender);
        this.$set(this.formModel, 'isRetrievedFromMoi', true);
        this.$set(this.formModel, 'fullName', this.userInfo.fullName);
      } else {
        this.$set(this.formModel, 'socialIdType', null);
        this.$set(this.formModel, 'socialId', null);
        this.$set(this.formModel, 'firstName', null);
        this.$set(this.formModel, 'fatherName', null);
        this.$set(this.formModel, 'grandFatherName', null);
        this.$set(this.formModel, 'familyName', null);
        this.$set(this.formModel, 'dateOfBirth', null);
        this.$set(this.formModel, 'nationalityCountryId', null);
        this.$set(this.formModel, 'sex', null);
        this.$set(this.formModel, 'isRetrievedFromMoi', false);
        this.$set(this.formModel, 'fullName', null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
    .show-note {
        cursor: pointer;
        color: var(--app-primary-color);
        font-weight: bold;
    }

::v-deep .case-info-text {
  word-break: break-all;
}
</style>